var _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateTimeGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.142578 4.2V12C0.142578 14.2091 1.93344 16 4.14258 16H12.1426C14.3517 16 16.1426 14.2091 16.1426 12V4.2H0.142578Z",
    fill: "#5F6877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0166 3C15.5725 1.27477 14.0064 0 12.1426 0H4.14258C2.27874 0 0.712638 1.27477 0.268596 3H16.0166Z",
    fill: "#5F6877"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1426 8C12.5903 8 12.1426 7.55228 12.1426 7C12.1426 6.44772 12.5903 6 13.1426 6C13.6949 6 14.1426 6.44772 14.1426 7C14.1426 7.55228 13.6949 8 13.1426 8Z",
    fill: "#9E9DAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14258 11C5.59029 11 5.14258 10.5523 5.14258 10C5.14258 9.44772 5.59029 9 6.14258 9C6.69486 9 7.14258 9.44772 7.14258 10C7.14258 10.5523 6.69486 11 6.14258 11Z",
    fill: "#9E9DAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1426 8C9.59029 8 9.14258 7.55228 9.14258 7C9.14258 6.44772 9.59029 6 10.1426 6C10.6949 6 11.1426 6.44772 11.1426 7C11.1426 7.55228 10.6949 8 10.1426 8Z",
    fill: "#9E9DAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14258 11C2.59029 11 2.14258 10.5523 2.14258 10C2.14258 9.44772 2.59029 9 3.14258 9C3.69486 9 4.14258 9.44772 4.14258 10C4.14258 10.5523 3.69486 11 3.14258 11Z",
    fill: "#9E9DAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTimeGray);
export default __webpack_public_path__ + "static/media/date-timeGray.2e8510e7299d91d0a11b75fc2e7a4bbf.svg";
export { ForwardRef as ReactComponent };